export const COLOR_MAP = {
    white: {
        backgroundColor: 'white',
        color: 'black',
        iconColor: 'black'
    },
    green: {
        backgroundColor: '#51A351',
        color: 'black',
        iconColor: 'black'
    },
    yellow: {
        backgroundColor: '#FADB4E',
        color: 'black',
        iconColor: 'black'
    },
    orange: {
        backgroundColor: '#F7931E',
        color: 'black',
        iconColor: 'black'
    },
    red: {
        backgroundColor: '#ED1C24',
        color: 'white',
        iconColor: 'white'
    },
    pink: {
        backgroundColor: '#ED1E79',
        color: 'white',
        iconColor: 'white'
    },
    purple: {
        backgroundColor: '#322279',
        color: 'white',
        iconColor: 'white'
    },
    blue: {
        backgroundColor: '#2962B1',
        color: 'white',
        iconColor: 'white'
    },
    black: {
        backgroundColor: 'black',
        color: 'white',
        iconColor: 'white'
    }
}